import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartBarsTrendUpFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 18V21M8 14V21M12 16V21M16 14V21M20 10V21M2 15L8.5 8.5L13 12L22 3",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChartBarsTrendUpFilled;
